import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__top-wrapper" }
const _hoisted_3 = { class: "footer__top" }
const _hoisted_4 = { class: "footer__main" }
const _hoisted_5 = { class: "footer__logo-description" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]

import { computed } from 'vue';
import SocialLinks from './SocialLinks.vue';
import ContactInfo from './ContactInfo.vue';
import useContext from '@/composables/useContext';
import Showrooms from './Showrooms.vue';
import MainLinks from './MainLinks.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EComFooter',
  setup(__props) {

const { settings } = useContext();

const contactInfo = computed(() => settings.value?.contactInfo || []);
const socialLinks = computed(() => settings.value?.socialLinks || []);
const mainLinks = computed(() => settings.value?.mainLinks || []);
const showrooms = computed(() => settings.value?.showrooms || []);
const description = computed(() => settings.value?.description);
const logoUrl = computed(() => {
  return settings.value?.logo?.filename;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ContactInfo, {
          class: "footer__contact-info",
          contact: _unref(contactInfo)
        }, null, 8, ["contact"]),
        _createVNode(SocialLinks, {
          class: "footer__social-links top-position",
          socials: _unref(socialLinks)
        }, null, 8, ["socials"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          class: "footer__logo",
          src: _unref(logoUrl)
        }, null, 8, _hoisted_6),
        _createElementVNode("div", {
          class: "footer__description",
          innerHTML: _unref(description)
        }, null, 8, _hoisted_7)
      ]),
      _createVNode(MainLinks, {
        class: "footer__links",
        links: _unref(mainLinks)
      }, null, 8, ["links"]),
      _createVNode(Showrooms, {
        class: "footer__showrooms",
        rooms: _unref(showrooms)
      }, null, 8, ["rooms"]),
      _createVNode(SocialLinks, {
        class: "footer__social-links bottom-position",
        socials: _unref(socialLinks)
      }, null, 8, ["socials"])
    ])
  ]))
}
}

})